import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { CommunityDetailDataObject } from 'models/service';

export const getCommunity = async ({ id, invitationToken }: { id: string; invitationToken?: string }) =>
  apiClient.get<CommunityDetailDataObject, ApiClientResponse<CommunityDetailDataObject>>(routes.community.get(id), {
    params: { invitation_token: invitationToken },
  });
